<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>商品列表</el-breadcrumb-item>
        </el-breadcrumb>


        <!-- 搜索 添加 -->
        <el-form :inline="true" style="margin-top: 20px;">
            <el-form-item>
                <el-input size="small" v-model="sousuo.name" placeholder="请输入商品名"></el-input>
            </el-form-item>
            <el-form-item label="是否实体">
                <el-select v-model="sousuo.entity" placeholder="请选择是否实体">
                    <el-option v-for="item in options3" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否下架">
                <el-select v-model="sousuo.isDisable" placeholder="请选择是否下架">
                    <el-option v-for="item in options4" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="chongzhi">重置</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="openGoods()">添加</el-button>
            </el-form-item>
        </el-form>


        <!-- 列表 -->
        <el-table size="small" :data="GoodsData" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%;" v-horizontal-scroll>
            <el-table-column align="center" sortable type="index" label="序号"></el-table-column>
            <!-- <el-table-column align="center" sortable prop="sort" label="排序" width="100"></el-table-column> -->
            <el-table-column align="center" sortable prop="name" label="商品名" width="100"></el-table-column>
            <el-table-column align="center" sortable prop="price" label="价格" width="100"></el-table-column>
            <el-table-column align="center" sortable prop="image" label="商品封面图" width="120">
                <template slot-scope="scope">
                    <el-image v-if="scope.row.image" style="width: 90px;height: 90px;" :src="scope.row.image"
                        :preview-src-list="[scope.row.image]" />
                    <div v-if="scope.row.image == null">没有图片</div>
                </template>
            </el-table-column>
            <el-table-column align="center" sortable prop="description" label="商品描述" width="120"></el-table-column>

            <el-table-column align="center" sortable prop="entity" :formatter="isShiti" label="是否实体"
                width="120"></el-table-column>
            <el-table-column align="center" sortable prop="type" :formatter="Type" label="货币类型"
                width="120"></el-table-column>
            <el-table-column align="center" sortable prop="totalCount" label="商品总数" width="120"></el-table-column>
            <el-table-column align="center" sortable prop="saleCount" label="销量数量" width="120"></el-table-column>
            <el-table-column align="center" sortable prop="inventoryCount" label="库存" width="120">
            </el-table-column>
            <el-table-column align="center" sortable prop="isDisable" :formatter="isXiajia" label="是否下架"
                width="120"></el-table-column>
            <el-table-column align="center" sortable prop="createTime" label="创建时间" width="140">
                <template slot-scope="scope">
                    <div>{{ transformDate(scope.row.createTime) }}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" sortable prop="updateTime" label="更新时间" width="140">
                <template slot-scope="scope">
                    <div>{{ transformDate(scope.row.updateTime) }}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="500" fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="upGoodCount(scope.row)">修改商品库存</el-button>
                    <el-button size="mini" type="primary" @click="getGoodsxq(scope.row)">查看商品详情</el-button>
                    <el-button size="mini" type="primary" @click="openGoods(scope.row)">修改商品信息</el-button>
                    <el-button size="mini" type="danger" @click="deleGoods(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 修改库存 -->
        <el-dialog title="修改库存界面" :visible.sync="editFormUpCount" width="60%">
            <el-radio v-model="radio" label="1">增加库存</el-radio>
            <el-radio v-model="radio" label="0">减少库存</el-radio>
            <div style="display: flex;margin-top: 20px;margin-left: 20px; align-items: center;">
                <span>数&nbsp;&nbsp;量&nbsp;:&nbsp;</span><el-input style="width: 70%;" v-model="count"
                    placeholder="请输入数量"></el-input>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click='closeUpCount()'>取消</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="upCount()"
                    v-if="radio == '1'">增加</el-button>
                <el-button size="small" type="danger" :loading="loading" @click="upCount()"
                    v-if="radio == '0'">减少</el-button>
            </div>
        </el-dialog>

        <!-- 编辑界面 -->
        <el-dialog :title="tit" :visible.sync="editFormVisiible" width="60%">
            <el-form label-width="120px">
                <el-form-item label="排序" prop="sort">
                    <el-input size="small" v-model="sort" auto-complete="off" placeholder="请输入排序"></el-input>
                </el-form-item>
                <el-form-item label="商品名" prop="name">
                    <el-input size="small" v-model="name" auto-complete="off" placeholder="请输入商品名"></el-input>
                </el-form-item>
                <el-form-item label="商品价格" prop="price">
                    <el-input size="small" v-model="price" auto-complete="off" placeholder="请输入商品价格"></el-input>
                </el-form-item>
                <el-form-item label="商品封面图">
                    <div style="display: flex; align-items: center;">
                        <el-upload action="" :http-request="mainImgUpload" :show-file-list="false" list-type="picture-card">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-image v-if="image" style="width: 140px;height: 140px;margin-left: 14px;" :src="image"
                            :preview-src-list="[image]" />
                    </div>
                </el-form-item>

                <el-form-item label="商品轮播图">
                    <div style="display: flex;">
                        <el-upload action="" :http-request="mainImgUpload1" :show-file-list="false"
                            list-type="picture-card">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                        <ul style="" class="urlLun">
                            <li v-for="(url, index) in urlArr" :key="url"
                                style="width: 140px;height: 140px;margin:3px 0 3px 14px;  position:relative">
                                <el-image v-if="url" style="width: 140px;height: 140px;" :src="url"
                                    :preview-src-list="[url]" />
                                <el-button class="deleUrl" type="danger" icon="el-icon-delete" circle
                                    @click="DeleUrl(index)"></el-button>
                            </li>
                        </ul>
                    </div>
                </el-form-item>

                <el-form-item label="商品描述" prop="description" style="margin-top: -14px;">
                    <el-input size="small" v-model="description" auto-complete="off" placeholder="请输入商品描述"></el-input>
                </el-form-item>
                <el-form-item label="是否实体">
                    <el-select v-model="entity" placeholder="请选择是否实体">
                        <el-option v-for="item in options" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="货币类型">
                    <el-select v-model="typeHb" placeholder="请选择货币类型">
                        <el-option v-for="item in optionsType" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品总数" prop="etotalCount">
                    <el-input size="small" v-model="totalCount" auto-complete="off" placeholder="请输入商品总数"></el-input>
                </el-form-item>
                <!-- <el-form-item label="库存" prop="inventoryCount">
          <el-input size="small" v-model="inventoryCount" auto-complete="off" placeholder="请输入商品库存"></el-input>
        </el-form-item> -->
                <el-form-item label="是否下架">
                    <el-select v-model="isDisable" placeholder="请选择是否下架">
                        <el-option v-for="item in options1" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click='closeDialog()'>取消</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="addGoods()"
                    v-if="tit == '添加'">添加</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="upGoods()"
                    v-if="tit == '修改'">修改</el-button>
            </div>
        </el-dialog>

        <!-- 查看详情 -->
        <el-dialog title="商品详情页：" :visible.sync="editFormDetails">
            <el-form label-width="120px">
                <el-form-item label="商品名：" prop="name">
                    <span v-html="this.Details.name"></span>
                </el-form-item>
                <el-form-item label="价格：" prop="price">
                    <span v-html="this.Details.price"></span>
                </el-form-item>
                <el-form-item label="商品封面图：">
                    <el-image v-if="this.Details.image" style="width: 140px;height: 140px;margin-left: 14px;"
                        :src="this.Details.image" :preview-src-list="[this.Details.image]" />
                </el-form-item>
                <el-form-item label="商品轮播图：">
                    <ul
                        style="display: flex; flex-wrap: wrap;overflow: auto; width: 100%;height: 160px;padding:0;margin:0;">
                        <li v-for="url in urlArr" :key="url" style="width: 140px;height: 140px;margin:3px 0 3px 14px">
                            <el-image v-if="url" style="width: 140px;height: 140px;" :src="url" :preview-src-list="[url]" />
                        </li>
                    </ul>
                </el-form-item>
                <el-form-item label="商品描述：" prop="description">
                    <span v-html="this.Details.description"></span>
                </el-form-item>
                <el-form-item label="是否实体：" prop="entity">
                    <span v-if="this.Details.entity == 0">虚体</span>
                    <span v-if="this.Details.entity == 1">实体</span>
                </el-form-item>
                <el-form-item label="货币类型：" prop="type ">
                    <span v-if="this.Details.type == 0">奖学金</span>
                    <span v-if="this.Details.type == 1">钻石</span>
                </el-form-item>
                <el-form-item label="商品总数：" prop="totalCount">
                    <span v-html="this.Details.totalCount"></span>
                </el-form-item>
                <el-form-item label="销量数量：" prop="saleCount">
                    <span v-html="this.Details.saleCount"></span>
                </el-form-item>
                <el-form-item label="库存：" prop="inventoryCount">
                    <span v-html="this.Details.inventoryCount"></span>
                </el-form-item>
                <el-form-item label="是否下架：" prop="isDisable">
                    <span v-if="this.Details.isDisable == 0">未下架</span>
                    <span v-if="this.Details.isDisable == 1">已下架</span>
                </el-form-item>
                <el-form-item label="创建时间：" prop="createTime">
                    {{ transformDate(this.Details.createTime) }}
                </el-form-item>
                <el-form-item label="更新时间：" prop="updateTime">
                    {{ transformDate(this.Details.updateTime) }}
                </el-form-item>
            </el-form>
        </el-dialog>

        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
</template>

<script>
import client from "@/utils/ossClient.js";
import Pagination from '../../components/Pagination'
import { getCommodityList } from '../../api/userMG'
import { getCommodityInfo } from '../../api/userMG'
import { addCommodity } from '../../api/userMG'
import { deleteCommodity } from '../../api/userMG'
import { upCommodity } from '../../api/userMG'
import { alterCommodityCount } from '../../api/userMG'
export default {
    data() {
        return {
            GoodsData: [],
            loading: false,
            editFormVisiible: false,
            tit: '添加',
            options: [{
                value: 0,
                label: '虚体'
            }, {
                value: 1,
                label: '实体'
            }],
            options1: [{
                value: 0,
                label: '未下架'
            }, {
                value: 1,
                label: '已下架'
            }],
            name: '',
            price: '',
            image: '',
            url: '',
            description: '',
            entity: '',
            totalCount: '',
            saleCount: '',
            inventoryCount: '',
            isDisable: '',
            typeHb: '',
            sort: '',
            createTime: '',
            updateTime: '',
            urlArr: [],
            editFormDetails: false,
            Details: [],
            editFormUpCount: false,
            id: '',
            type: '',
            radio: '1',
            count: '',
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 20,
                total: 10
            },
            sousuo: {
                name: '',
                entity: -1,
                isDisable: -1
            },
            options3: [{
                value: -1,
                label: '全部'
            }, {
                value: 0,
                label: '虚体'
            }, {
                value: 1,
                label: '实体'
            }],
            options4: [{
                value: -1,
                label: '全部'
            }, {
                value: 0,
                label: '未下架'
            }, {
                value: 1,
                label: '已下架'
            }],
            optionsType: [{
                value: 0,
                label: '奖学金'
            }, {
                value: 1,
                label: '钻石'
            }]
        }
    },
    created() {
        this.getData(1);
    },
    // 注册组件
    components: {
        Pagination
    },
    methods: {
        // 搜索事件
        search() {
            this.getData(1)
        },
        // 重置数据
        chongzhi() {
            this.sousuo.name = ''
            this.sousuo.entity = -1
            this.sousuo.isDisable = -1
            this.getData(1)
        },
        // 关闭修改对话框
        closeUpCount() {
            this.editFormUpCount = false
            this.$message({
                type: 'info',
                message: '已取消修改'
            })
        },
        upCount() {
            let data = {
                id: this.id,
                type: this.radio,
                count: this.count
            }
            alterCommodityCount(data).then((res) => {
                if (res.code == 200) {
                    this.editFormUpCount = false
                    this.$message.success(res.msg)
                    this.getData(1)
                    this.count = ''
                } else {
                    this.editFormUpCount = false
                    this.$message.error(res.msg);
                }
            })
        },
        // 打开修改库存编辑页
        upGoodCount(row) {
            console.log(row)
            this.editFormUpCount = true;
            this.id = row.id;
        },
        // 删除图片
        DeleUrl(index) {
            this.urlArr
            this.urlArr.splice(index, 1);
        },
        // 详情
        getGoodsxq(row) {
            this.loading = true;
            this.editFormDetails = true;
            let data = {
                id: row.id
            }
            getCommodityInfo(data).then((res) => {
                this.loading = false;
                console.log(res)
                if (res.code != 200) {
                    this.$Message({
                        type: "info",
                        message: res.msg
                    });
                } else {
                    this.Details = res.data.data;
                    this.urlArr = this.Details.url.split(',')
                    return;
                }
            })
        },
        // 添加
        addGoods() {
            this.loading = true
            addCommodity({
                name: this.name,
                price: this.price,
                image: this.image,
                url: this.urlArr,
                description: this.description,
                entity: this.entity,
                totalCount: this.totalCount,
                inventoryCount: this.inventoryCount,
                isDisable: this.isDisable,
                type: this.typeHb,
                sort: this.sort,
                createTime: '',
                updateTime: ''
            }).then((res) => {
                this.loading = false;
                if (res.code == 200) {
                    this.editFormVisiible = false
                    this.$message.success(res.msg)
                    this.getData(1)
                } else {
                    this.editFormVisiible = false
                    this.$message.error(res.msg);
                }
            })
        },
        // 修改
        upGoods() {
            this.loading = true
            upCommodity({
                id: this.id,
                name: this.name,
                price: this.price,
                image: this.image,
                url: this.urlArr,
                sort: this.sort,
                description: this.description,
                entity: this.entity,
                totalCount: this.totalCount,
                saleCount: this.saleCount,
                // inventoryCount:this.inventoryCount,
                isDisable: this.isDisable,
                type: this.typeHb,
                createTime: this.createTime,
            }).then((res) => {
                this.loading = false;
                if (res.code == 200) {
                    this.editFormVisiible = false
                    this.$message.success(res.msg)
                    this.getData(1)
                } else {
                    this.editFormVisiible = false
                    this.$message.error(res.msg);
                }
            })
        },
        // 自定义上传方法 轮播的
        mainImgUpload1(file) {
            // 判断扩展名
            const tmpcnt = file.file.name.lastIndexOf(".");
            const exname = file.file.name.substring(tmpcnt + 1);
            const names = ["jpg", "jpeg", "webp", "png", "bmp"];
            if (names.indexOf(exname) < 0) {
                this.$message.error("不支持的格式!");
                return;
            }
            const fileName = file.file.uid + "." + exname;
            client
                .put(fileName, file.file)
                .then((res) => {
                    if (res.url) {
                        this.urlArr.push(res.url)
                    } else {
                        this.$message.error("文件上传失败");
                    }
                })
                .catch((err) => { });
        },
        // 自定义上传方法 图片的
        mainImgUpload(file) {
            // 判断扩展名
            const tmpcnt = file.file.name.lastIndexOf(".");
            const exname = file.file.name.substring(tmpcnt + 1);
            const names = ["jpg", "jpeg", "webp", "png", "bmp"];
            if (names.indexOf(exname) < 0) {
                this.$message.error("不支持的格式!");
                return;
            }
            const fileName = file.file.uid + "." + exname;
            client
                .put(fileName, file.file)
                .then((res) => {
                    if (res.url) {
                        this.image = res.url
                    } else {
                        this.$message.error("文件上传失败");
                    }
                })
                .catch((err) => { });
        },
        // 关闭编辑对话框
        closeDialog() {
            this.editFormVisiible = false
            this.$message({
                type: 'info',
                message: '已取消编辑'
            })
        },
        // 打开编辑器
        openGoods(row) {
            this.editFormVisiible = true;
            if (row != undefined && row != "undefined") {
                this.tit = "修改"
                this.id = row.id
                this.name = row.name
                this.price = row.price
                this.image = row.image
                this.urlArr = row.url.split(',')
                this.description = row.description
                this.entity = row.entity
                this.totalCount = row.totalCount
                this.saleCount = row.saleCount
                // this.inventoryCount=row.inventoryCount;
                this.isDisable = row.isDisable
                this.typeHb = row.type
                this.sort = row.sort
                this.createTime = row.createTime
                this.updateTime = row.updateTime
            } else {
                this.tit = "添加"
                this.sort = ''
                this.name = ''
                this.price = ''
                this.image = ''
                this.urlArr = []
                this.description = ''
                this.entity = ''
                this.totalCount = ''
                this.inventoryCount = ''
                this.isDisable = ''
                this.typeHb = ''
            }
        },
        // 是否实体
        isShiti: function (row) {
            if (row.entity == 0) {
                return "虚体"
            } else if (row.entity == 1) {
                return "实体"
            }
        },
        // 是否下架
        isXiajia: function (row) {
            if (row.isDisable == 0) {
                return "未下架"
            } else if (row.isDisable == 1) {
                return "已下架"
            }
        },
        // 货币类型
        Type: function (row) {
            if (row.type == 0) {
                return "奖学金"
            } else if (row.type == 1) {
                return "钻石"
            }
        },
        // 删除
        deleGoods(row) {
            this.$confirm('确定删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'success'
            }).then(() => {
                let data = {
                    id: row.id
                }
                deleteCommodity(data).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg)
                        this.getData(1)
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        // 分页插件事件
        callFather(parm) {
            this.pageparm.page = parm.currentPage
            this.getdata(parm.currentPage)
        },
        // 获取数据
        getData(page) {
            this.loading = true;
            let data = {
                name: this.sousuo.name,
                entity: this.sousuo.entity,
                isDisable: this.sousuo.isDisable,
                page: (page - 1) * 20
            }
            getCommodityList(data).then((res) => {
                this.loading = false;
                if (res.code == 200) {
                    this.GoodsData = res.data.list;
                    this.pageparm.currentPage = page;
                    this.pageparm.total = res.data.count;
                    return;
                } else {
                    this.$Message({
                        type: "info",
                        message: res.msg
                    })
                }
            })
        }
    }


}
</script>

<style>
li {
    list-style: none;
}

.urlLun {
    display: flex;
    flex-wrap: wrap;
    overflow: auto;
    width: 100%;
    height: 160px;
    padding: 0;
    margin: 0;
}

.deleUrl {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: none;
}

.urlLun li:hover .deleUrl {
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/views/goods/Goods.vue